import './index.css';

import AppLayout from 'app/layout/wrapper/AppLayout';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import { NavigationProvider } from 'shared/providers/NavigationProvider';
import { NotificationProvider } from 'shared/providers/NotificationProvider';
import i18n from '../i18n';

const App = () => {
  return (
    
    <I18nextProvider i18n={i18n}>
      <BrowserRouter>
        <NotificationProvider>
          <NavigationProvider>
            <AppLayout />
          </NavigationProvider>
        </NotificationProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;